/** 비교하려는 A배열, B배열의 원소 중 하나라도 같은 것이 있으면 true를 반환한다.
 *  */
export const checkArrayIntersection = <T>(arrayA: T[], arrayB: T[]): boolean => {
  const setA = new Set(arrayA);
  return arrayB.some((element) => setA.has(element));
};
